import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../hooks/useSubscription';

function graceCopy(endsAt: string | null | undefined): string {
  if (!endsAt) {
    return 'Your card payment failed. Campaigns already sending keep going for 3 days. Research, enrichment, and new campaigns wait until the card is updated.';
  }
  const ms = new Date(endsAt).getTime() - Date.now();
  const days = Math.max(1, Math.ceil(ms / (24 * 60 * 60 * 1000)));
  const when = days === 1 ? '1 day' : `${days} days`;
  return `Your card payment failed. Campaigns already sending keep going for ${when}. Research, enrichment, and new campaigns wait until the card is updated.`;
}

export default function PaymentHoldBanner() {
  const { entitlements, loading } = useSubscription();
  const navigate = useNavigate();
  const hold = entitlements.billingHold;
  if (loading || (hold !== 'grace' && hold !== 'paused')) return null;

  const paused = hold === 'paused';
  return (
    <div
      className={`flex shrink-0 flex-wrap items-center justify-between gap-3 px-4 py-2.5 text-sm ${
        paused ? 'bg-neutral-90 text-white' : 'bg-[#F3E7C8] text-neutral-90'
      }`}
      data-testid="payment-hold-banner"
      role="status"
    >
      <p className="min-w-0">
        {paused
          ? 'Sending is paused until the card on file is updated. Your contacts and campaigns are still here.'
          : graceCopy(entitlements.paymentGraceEndsAt)}
      </p>
      <button
        type="button"
        className={`inline-flex min-h-9 items-center rounded-btn px-3 text-sm font-medium ${
          paused ? 'bg-white text-neutral-90' : 'bg-neutral-90 text-white'
        }`}
        onClick={() => navigate('/app/billing')}
      >
        Update card
      </button>
    </div>
  );
}
